var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClosedOutcome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.00003 1C5.29742 1 5.53849 1.24108 5.53849 1.53846V3.15385H6.43593C6.44367 3.15385 6.45142 3.15401 6.45916 3.15435C7.55756 3.20177 8.51678 3.91231 8.88223 4.94922C8.98108 5.22969 8.83385 5.5372 8.55338 5.63605C8.2729 5.7349 7.9654 5.58767 7.86655 5.30719C7.64847 4.68844 7.07801 4.26338 6.42348 4.23077H3.56413C2.67198 4.23077 1.94875 4.954 1.94875 5.84615C1.94875 6.73831 2.67198 7.46154 3.56413 7.46154H6.43593C7.92285 7.46154 9.12824 8.66693 9.12824 10.1538C9.12824 11.6408 7.92285 12.8462 6.43593 12.8462H5.53849V14.4615C5.53849 14.7589 5.29742 15 5.00003 15C4.70265 15 4.46157 14.7589 4.46157 14.4615V12.8462H3.56413C3.55639 12.8462 3.54864 12.846 3.54091 12.8457C2.4425 12.7982 1.48328 12.0877 1.11783 11.0508C1.01898 10.7703 1.16621 10.4628 1.44669 10.364C1.72716 10.2651 2.03466 10.4123 2.13352 10.6928C2.35159 11.3116 2.92205 11.7366 3.57658 11.7692H6.43593C7.32808 11.7692 8.05131 11.046 8.05131 10.1538C8.05131 9.26169 7.32808 8.53846 6.43593 8.53846H3.56413C2.07721 8.53846 0.871826 7.33307 0.871826 5.84615C0.871826 4.35923 2.07721 3.15385 3.56413 3.15385H4.46157V1.53846C4.46157 1.24108 4.70265 1 5.00003 1Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosedOutcome);
export default __webpack_public_path__ + "static/media/closed_outcome.c22a52bfc3ed0a130d5650b98d358573.svg";
export { ForwardRef as ReactComponent };